export const DateFormats = {
  primary: 'YYYY-MM-DD HH:mm:ss',
};
